<script>
import gkSchedule from 'gkConUI/con-schedule/v1'

import utils from '@/utils'
import { mapState } from 'vuex'

export default {
  components: {
    gkSchedule
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['config'])
  },
  updated () {
    utils.weixinshare({
      title: this.config.wechat_share.schedules_title,
      imgUrl: this.config.wechat_share.default_logo,
      desc: this.config.wechat_share.default_desp
    })
  },
  mounted () {
    if (this.config.wechat_share.schedules_title) {
      utils.weixinshare({
        title: this.config.wechat_share.schedules_title,
        imgUrl: this.config.wechat_share.default_logo,
        desc: this.config.wechat_share.default_desp
      })
    }
  },
  render () {
    return (<gkSchedule />)
  }
}
</script>
